import { ReportType } from '../index'
import { Table, Header, EmptyRow } from '../../../Components/EnterpriseTable'
import Row from './Row'

type ReportRowParams = {
  reports: ReportType[]
  error?: boolean
}

const ReportTable = ({ reports, error }: ReportRowParams) => (
  <Table>
    <thead>
      <tr>
        <Header>Date Created</Header>
        <Header>Label</Header>
        <Header>Options</Header>
        <Header>Date Range</Header>
        <Header>Status</Header>
        <Header align="right">Download</Header>
      </tr>
    </thead>
    <tbody>
      {error ? (
        <EmptyRow>There was an error fetching reports</EmptyRow>
      ) : reports.length === 0 ? (
        <EmptyRow>No reports found</EmptyRow>
      ) : (
        reports.map((report) => (
          <Row
            key={`${report.reportName}-${report.createdDatetime}`}
            report={report}
          />
        ))
      )}
    </tbody>
  </Table>
)

export default ReportTable
